export default {
  title: 'HiTeach课堂桌游',
  pvpGame: '摘星星',
  moleGame: '打地鼠',
  tfGame: '火箭升空',
  pickGame: '挑人转盘',
  punchBoardGame: '戳戳乐',
  
  // 游戏说明标题
  gameInfoTitle: '游戏说明',
  close: '关闭',
  
  // 词汇掉落说明
  pvpGameTitle: '摘星星',
  pvpGameDesc: '在热带小岛上，词语像流星雨般从天而降！\n两位玩家要在限定时间内，抓住正确词语、闪避错误选项，谁能快速又精准地成为词汇猎人王？',
  
  // 打地鼠说明
  moleGameTitle: '打地鼠',
  moleGameDesc: '一人对战！知识版的打地鼠登场～\n地鼠们冒出头带来真假资讯，你能在最短时间内准确「敲」出正确答案，击退那些来搅乱的错误吗？',
  
  // 火箭升空说明
  tfGameTitle: '火箭升空',
  tfGameDesc: '准备升空，智慧对决启动！\n两位太空人面对是非题的挑战，答对才能让火箭直冲星际，答错就原地打转～谁能最先飞出大气层成为知识宇航员？',
  
  // 挑人转盘说明
  pickGameTitle: '挑人转盘',
  pickGameDesc: '转动命运的转盘！\n支持个人挑选、组别挑选或自订选项，让选择变得更有趣更公平。转盘旋转，答案揭晓！',
  
  // 戳戳乐说明
  punchBoardGameTitle: '戳戳乐',
  punchBoardGameDesc: '戳破惊喜的时刻！\n每个洞都藏着不同的惊喜，戳破表面探索内容。支持多种版面大小和动画效果，让选择充满期待！',
  
  // 按钮文字
  play: '开始游戏'
}